export const BULK_UPLOAD_LIMIT = 30;
